import { render, staticRenderFns } from "./VerProveedorModal.vue?vue&type=template&id=0174e1a5&"
import script from "./VerProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./VerProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0174e1a5', component.options)
    } else {
      api.reload('0174e1a5', component.options)
    }
    module.hot.accept("./VerProveedorModal.vue?vue&type=template&id=0174e1a5&", function () {
      api.rerender('0174e1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedor/VerProveedorModal.vue"
export default component.exports